import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Modal, Button } from '@mui/material';
import CountryDeleteModal from "./deleteModal";
import { tableDeleteButtonSx, tableViewButtonSx } from "../../styles/actionStyles";
import { integratorTypeLabel } from "./integratorType";
import CopyablePhone from "../../components/copyablePhone";

// Open integrators take DAREs and farmers at eK Link sign-up; Closed ones only by invitation.
const ECOSYSTEM_CHIP = {
  OPEN: { label: 'Open', icon: 'lock_open', color: '#3B6404', backgroundColor: '#EEF7E6' },
  CLOSED: { label: 'Closed', icon: 'lock', color: '#4A4A5A', backgroundColor: '#F1F1F1' },
};

export default function EcosystemIntegratorsColumn({ setAlert, setOpenAlert, setResponseMsg, setLoading, getEcosytem }) {
  const navigate = useNavigate();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const ALERT_DURATION = 2000;

  const alertClose = () => {
    setAlert('');
  };

  const handleOpenDeleteModal = (id) => {
    setSelectedId(id);
    setOpenDeleteModal(true);
  };

  const truncateText = (value, maxLength = 34) => {
    if (!value) return '-';
    return value.length > maxLength ? `${value.slice(0, maxLength)}...` : value;
  };

  const ecosystemColumns = [
    {
      field: 'integratorName',
      headerName: 'E. Integrator',
      flex: 1,
      minWidth: 220,
      sortable: false,
      renderCell: (params) => {
        const value = params.row.integratorName;
        return (
          <Typography sx={{ fontSize: 16, lineHeight: '24px', letterSpacing: '0.15px', color: '#1C1B1F' }}>
            {value || '-'}
          </Typography>
        );
      },
    },
    {
      field: 'countryName',
      headerName: 'Country',
      flex: 0.9,
      minWidth: 160,
      sortable: false,
      renderCell: (params) => {
        const value = params.row.countryName;
        return (
          <Typography sx={{ fontSize: 16, lineHeight: '24px', letterSpacing: '0.15px', color: '#1C1B1F' }}>
            {value || '-'}
          </Typography>
        );
      },
    },
    {
      field: 'phoneNumber',
      headerName: 'Phone Number',
      flex: 0.9,
      minWidth: 190,
      sortable: false,
      renderCell: (params) => (
        <CopyablePhone
          phoneNumber={params.row.phoneNumber}
          countryCode={params.row.countryCode}
          textSx={{ fontSize: 16, lineHeight: '24px', letterSpacing: '0.15px', color: '#1C1B1F' }}
        />
      ),
    },
    {
      field: 'integratorType',
      headerName: 'Integrator Type',
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        const value = params.row.integratorType;
        return (
          <Typography sx={{ fontSize: 16, lineHeight: '24px', letterSpacing: '0.15px', color: '#1C1B1F' }}>
            {integratorTypeLabel(value)}
          </Typography>
        );
      },
    },
    {
      field: 'isOpen',
      headerName: 'Ecosystem',
      flex: 0.7,
      minWidth: 140,
      sortable: false,
      renderCell: (params) => {
        const chip = ECOSYSTEM_CHIP[params.row.isOpen ? 'OPEN' : 'CLOSED'];
        return (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.75,
              px: 1.25,
              height: 32,
              borderRadius: '999px',
              backgroundColor: chip.backgroundColor,
              color: chip.color,
            }}
          >
            <span className="material-symbols-rounded" style={{ fontSize: 16 }}>{chip.icon}</span>
            <Typography sx={{ fontSize: 14, lineHeight: '20px', letterSpacing: '0.1px', fontWeight: 500, color: 'inherit' }}>
              {chip.label}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: 'licenseName',
      headerName: 'License',
      flex: 0.95,
      minWidth: 180,
      sortable: false,
      renderCell: (params) => {
        const value = params.row.licenseName || '-';
        return (
          <Typography sx={{ fontSize: 16, lineHeight: '24px', letterSpacing: '0.15px', color: '#1C1B1F' }}>
            {truncateText(value, 20)}
          </Typography>
        );
      },
    },
    {
      field: "actions",
      headerName: "Action",
      flex: 1.15,
      minWidth: 220,
      sortable: false,
      renderCell: (params) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, width: '100%' }}>
            <Button
              onClick={() => navigate(`/ecosystemPartnersView/${params.row.id}?type=edit`)}
              startIcon={<span className="material-symbols-rounded">visibility</span>}
              sx={tableViewButtonSx}
            >
              View
            </Button>

            <Button
              onClick={() => handleOpenDeleteModal(params.row.id)}
              startIcon={<span className="material-symbols-rounded">delete</span>}
              sx={tableDeleteButtonSx}
            >
              Delete
            </Button>
          </Box>

          <Modal open={openDeleteModal} onClose={() => setOpenDeleteModal(false)} BackdropProps={{ sx: { backgroundColor: "rgba(0, 0, 0, 0.1)" } }}>
            <div>
              <CountryDeleteModal onClose={() => setOpenDeleteModal(false)} getEcosytem={getEcosytem} selectedId={selectedId} alertClose={alertClose} setOpenAlert={setOpenAlert} setResponseMsg={setResponseMsg} setAlert={setAlert} ALERT_DURATION={ALERT_DURATION} setLoading={setLoading} />
            </div>
          </Modal>
        </>
      ),
    },
  ];

  return ecosystemColumns;
}
